import React, { useState } from 'react';
import styled from 'styled-components';
import {
  fontSize,
  minBreakpointQuery,
  standardColours,
  visuallyHidden,
} from '../styles';
import { RecaptchaText } from './ui';

const StyledNewsletterSignupForm = styled.form``;

const StyledFormInner = styled.div`
  display: flex;
  border-bottom: 1px solid ${standardColours.white};
`;

const StyledLabel = styled.label`
  flex-grow: 1;

  span {
    ${visuallyHidden()}
  }
`;

const StyledInput = styled.input`
  background: none;
  border: none;
  padding: 10px 5px;
  line-height: 1.4;
  color: ${standardColours.white};
  width: 100%;

  &::placeholder {
    color: ${standardColours.white};
  }
`;

const StyledButton = styled.button`
  position: relative;
  background: none;
  color: ${standardColours.white};
  border: none;
  padding: 14px;

  &:after {
    content: '➔';
    position: absolute;
    top: 50%;
    left: 50%;
    color: inherit;
    ${fontSize(16)};
    transform: translate(-50%, -50%);
  }

  span {
    ${visuallyHidden()}
  }
`;

const StyledRecaptchaText = styled(RecaptchaText)`
  margin-top: 20px;
`;

const StyledText = styled.p`
  margin-top: 16px;

  ${minBreakpointQuery.small`
    margin-top: 20px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 24px;
  `}
`;

const NewsletterSignupForm = ({ ...props }) => {
  const [submitted, setSubmitted] = useState(false);

  const submitForm = e => {
    e.preventDefault();

    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute(process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY, {
          action: 'submit',
        })
        .then(async function (token) {
          const response = await fetch('/.netlify/functions/recaptcha', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              token: token,
            }),
          });

          const recaptchaResponse = await response.json();

          if (recaptchaResponse.score >= 0.5) {
            const newsletterForm = document.getElementById('newsletter');
            const formData = new FormData(newsletterForm);
            const email = formData.get('email');

            fetch('/.netlify/functions/newsletter-signup', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                email: email,
              }),
            })
              .then(response => {
                if (!response.ok) {
                  throw response;
                }

                setSubmitted(true);
              })
              .catch(error => error.json().then(err => console.log(err.msg)));
          }
        });
    });
  };

  return !submitted ? (
    <StyledNewsletterSignupForm
      id="newsletter"
      name="newsletter"
      method="POST"
      onSubmit={e => submitForm(e)}
      {...props}
    >
      <StyledFormInner>
        <StyledLabel>
          <span>Email</span>
          <StyledInput
            type="email"
            name="email"
            placeholder="email address"
            required
          />
        </StyledLabel>
        <StyledButton type="submit" title="Submit">
          <span>Submit</span>
        </StyledButton>
      </StyledFormInner>
      <StyledRecaptchaText />
    </StyledNewsletterSignupForm>
  ) : (
    <StyledText>Thanks for signing up ✓</StyledText>
  );
};

export default NewsletterSignupForm;
